import { Directive} from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
    selector: 'input[nifValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NIFValidationDirective, multi: true }],
    standalone: false
})
export class NIFValidationDirective implements Validator {

  validate(c: FormControl): { [key: string]: any } {

    if (!c.value)
      return null;

    const obj = { 'invalidNif': true };
    var nifAsArray: number[] = (typeof c.value) === 'string' ? c.value?.split('') : c.value?.toString()?.split('');
    if (nifAsArray.length != 9 && nifAsArray.length != 0)
      return obj;
    const controlDigit = nifAsArray.splice(nifAsArray.length - 1, 1)[0];
    nifAsArray = nifAsArray.map((x, i) => { return Number(x) * (9 - i) });
    var checkDigit = nifAsArray.reduce((a, b) => { return a + b });
    checkDigit = (checkDigit % 11);
    checkDigit = checkDigit < 2 ? 0 : 11 - checkDigit;
    return checkDigit != controlDigit ? { 'invalidNif': true } : null;
  }
}
